<template>
    <div id="profil-formation" slot="layout-content">
      <b-container>
      <h1 v-if="surveyStep==1">Mon profil formation</h1>
      <h1 v-else-if="surveyStep==2">Mon suivi professionnel après 6 mois</h1>
      <h1 v-else-if="surveyStep==5">Mon suivi professionnel après 12 mois</h1>
      <span v-if="completedForm">
        <div class="alert alert-success text-center">
          Merci d'avoir pris le temps de répondre à ce questionnaire.<br>
        </div>
        <b-button @click="$router.push({ name: 'Dashboard' })" variant="secondary" class="btn-fixed-bottom btn-block">Retour au tableau de bord</b-button>
      </span>
      <span v-else>
      <div class="alert alert-primary" style="font-size:0.9rem;">
        Afin de nous aider à mieux connaître les candidats au programme Digital Citizen, merci de répondre à ce bref questionnaire.
        <br>
        Ces informations ne seront jamais utilisées à des fins commerciales.
      </div>
        <div v-for="q in profileSurvey" :key='q.id'>
        <transition name="fade">
          <b-form-group v-show="!q.alreadyAnswered && profileSurveyToDisplay.includes(q.id)" :label="q.title" class="text-secondary font-weight-bold mt-2 pb-3 border-bottom text-left">
            <template v-if="q.type=='radio'">
              <b-form-radio-group :name="''+q.id" class="text-dark mt-2" v-model="q.checked" stacked @change="updateRadio(q, $event)">
                <template v-for="p in q.proposals">
                  <div :key="'div-'+p.id" class="proposal">
                    <b-form-radio :key="'radio-'+p.id" :name="''+q.id" :value="p.id" class="mr-1 font-weight-normal">{{ p.title }}</b-form-radio>
                    <b-form-input v-if="p.free_field==true" :key="'input-'+p.id" class="additional-response" placeholder="Veuillez préciser" :disabled="p.id != q.checked" v-model="p.freeFieldValue" @blur="updateFreeField(q, p.id, p.freeFieldValue)"></b-form-input>
                  </div>
                </template>
              </b-form-radio-group>
            </template>
            <template v-else-if="q.type=='checkbox'">
              <b-form-checkbox-group :name="''+q.id" class="text-dark mt-2" stacked v-model="q.checked">
                <template v-for="p in q.proposals">
                  <div :key="'div-'+p.id" class="proposal">
                    <!-- <span class="text-danger">{{form[index]['proposals'][pIndex]['checked']}}</span> -->
                    <b-form-checkbox :key="'checkbox-'+p.id" class="mr-1 font-weight-normal" :value="p.id" @change="updateCheckbox(q, p)">{{ p.title }}</b-form-checkbox>
                    <b-form-input v-if="p.free_field==true" placeholder="Veuillez préciser" :disabled="!q.checked.includes(p.id)" v-model="p.freeFieldValue" :key="'input-'+p.id" class="additional-response ml-1 w-auto" @blur="updateFreeField(q, p, p.freeFieldValue)" style="height:1.4rem"></b-form-input>
                  </div>
                </template>
              </b-form-checkbox-group>
            </template>
            <template v-else-if="q.type=='text'">
                <template v-for="p in q.proposals">
                  <template v-if="q.title=='Votre code postal'">
                    <b-form-input :key="'input-'+p.id" :placeholder="p.title" maxlength="5" v-model="p.value" class="text-dark w-auto mt-2" @keypress.native="allowOnlyNumericValue($event)" @blur="updateText(p)" :state="postalCodeState"></b-form-input>
                    <b-form-invalid-feedback v-show="!postalCodeState" id="input-live-feedback" :key="'input-'+p.id+'-feedback'">
                      Votre code postal ne semble pas valide, veuillez vérifier qu'il soit composé de 5 chiffres.
                    </b-form-invalid-feedback>
                  </template>
                  <b-form-input v-else :key="'input-'+p.id" :placeholder="p.title" v-model="p.value" class="text-dark w-auto" @blur="updateText(p)"></b-form-input>
                </template>
            </template>
          </b-form-group>
        </transition>
        </div>
        <b-form-group v-if="surveyStep==1 && !answeredSurveyAgreement" label="Acceptez-vous d'être recontacté(e) par email dans les 6 à 12 prochains mois dans le cadre du suivi de votre évolution professionnelle ?" class="text-secondary mt-2 pb-3 border-bottom font-weight-bold text-left">
          <b-form-radio-group name="agreement" v-model="surveyAgreement" class="text-dark font-weight-normal text-left mt-2" stacked @change="updateAgreement($event)">
            <b-form-radio name="agreement" value="1" class="mr-1">Oui</b-form-radio>
            <b-form-radio name="agreement" value="0" class="mr-1">Non</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-button @click="refreshSurvey()" variant="secondary" class="btn-fixed-bottom btn-block">Valider les informations</b-button>
      </span>
      <b-card class="disclaimer-rgpd mt-4" bg-variant="info" text-variant="dark" border-variant="dark">
          En conformité avec les exigences du Réglement Général sur la Protection des données (RGPD), nous vous informons que nous nous tenons à votre disposition pour toute demande portant sur vos droits d'accès, de rectification et d'opposition concernant vos données personnelles à l'adresse email <a href="mailto:technique@icdlfrance.org" class="text-secondary">technique@icdlfrance.org</a>.
      </b-card>
      </b-container>
    </div>
</template>

<script>
import Store from '@/store/index.js'
import surveyApi from '@/services/survey.js'

export default {
  methods: {
    checkPostalCode(postalCode){
      this.postalCodeState = (postalCode == null || postalCode.trim().length!=5 || postalCode != parseInt(postalCode)) ? false : null;
    },
    formattedDate(date) {
        return date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
    },
      async updateRadio(survey, idProposal, freeField='') {
        await this.$nextTick(() => {
          this.$parent.$parent.updateSurveyToDisplay("profile")
          survey.proposals.forEach(prop => {
            if (prop.id!=idProposal && prop.free_field==true) {
              prop.freeFieldValue=""
            }
          })
          let obj= {};
          obj.freeField = freeField;
          surveyApi.post('response/new/'+idProposal, obj).then(() => {})
        })
      },
    async updateCheckbox(survey, proposal, freeField="") {
      await this.$nextTick(() => {
        this.$parent.$parent.updateSurveyToDisplay("profile");
        let obj= {};
        if (survey.checked.includes(proposal.id)) {
          obj.freeField = freeField;
          surveyApi.post('response/new/'+proposal.id, obj).then({})
        }
        else {
          if(proposal.free_field==true) {
            proposal.freeFieldValue = ""
          }
          surveyApi.delete('response/delete/'+proposal.id).then({})
        }
      })
    },
    async updateText(proposal) {
      // vérifie le format s'il s'agit de la question demandant le code postal
      if(proposal.id==70 && proposal.value.length>0) {
        this.checkPostalCode(proposal.value)
        if(this.postalCodeState==false) {
          console.log("false")
          return
        }
      }
      this.$parent.$parent.updateSurveyToDisplay("profile");
      let obj= {};
      obj.freeField = proposal.value;
      surveyApi.post('response/new/'+proposal.id, obj).then({})
    },
    allowOnlyNumericValue(evt) {
      if (evt.which < 48 || evt.which > 57)
      {
        evt.preventDefault();
      }
    },
    async updateAgreement(valueEvent) {
      let obj = {};
      obj.agree = (valueEvent == 1) ? true : false
      await surveyApi.post('response/agreement', obj).then((resp) => {
          let agreementStatus = resp.data[0]
          Store.dispatch('update_survey_agreement', ({
            agreement : agreementStatus['accord_sondage'], 
            agreementDate : agreementStatus['date_accord_sondage']
          }));
      })
    },
    async updateFreeField(survey, proposal, freeFieldValue="") {
      if(survey.type=="radio") {
        this.updateRadio(survey, proposal, freeFieldValue)
      }
      if(survey.type=="checkbox") {
        this.updateCheckbox(survey, proposal, freeFieldValue)
      }
    },
    async refreshSurvey() {
      this.$parent.$parent.setLoading(true, "Validation du questionnaire")
      await window.setTimeout(async () => {
        await this.$parent.$parent.getProfileSurvey()
        this.$parent.$parent.setLoading(false)
      }, 300)
    }
  },
  data () {
    return {
      name: 'ProfilFormation',
      profileSurvey: [],
      postalCodeState: null,
      surveyAgreement: (Store.getters.getDateAccordSondage() == null || Store.getters.getDateAccordSondage() == "null") ? null : Store.getters.getAccordSondage(),
      timeout: null,
      completedForm: false,
      answeredSurveyAgreement: this.$parent.$parent.answeredSurveyAgreement
    }
  },
  computed: {
    loadedProfileSurvey() {return this.$parent.$parent.loadedProfileSurvey},
    profileSurveyToDisplay() {return this.$parent.$parent.profileSurveyToDisplay},
    surveyStep() {return this.$parent.$parent.surveyStep},
  },
  created() {
    if(this.loadedProfileSurvey!=true) {
      this.$parent.$parent.setLoading(true, "Chargement du questionnaire")
    }
  },
  mounted() {
    if(this.loadedProfileSurvey==true) {
        this.profileSurvey = this.$parent.$parent.profileSurvey;
    }
  },
  beforeDestroy() {
    if(this.surveyStep==1) {
      let postalCodeQuestion = this.profileSurvey.find(surveyQuestion => surveyQuestion.id==14)
      let postalCodeProposal = postalCodeQuestion.proposals.find(prop => prop.id==70)
      this.checkPostalCode(postalCodeProposal.value)
      if(this.postalCodeState==false) {
        postalCodeProposal.value = ""
      }
    }
  },
  watch: {
    loadedProfileSurvey() {
      if(this.loadedProfileSurvey==true) {
        this.profileSurvey = this.$parent.$parent.profileSurvey;
        this.answeredSurveyAgreement= Store.getters.getDateAccordSondage() != "null";
        if(this.profileSurvey.filter((question) => !question.alreadyAnswered && this.profileSurveyToDisplay.includes(question.id)).length==0 && this.answeredSurveyAgreement) {
          this.completedForm = true;
        }
        this.$parent.$parent.setLoading(false)
      }
    }
  }
}
</script>

<style scoped>
  h1 {
    font-weight: bold;
    margin-bottom: 20px;
  }
  #display_identity_modal_btn {
    margin-top: 1.5rem;
    width: 100%;
  }
  .proposal {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
  }
  .test-input {
    width: auto;
    height: 0.9rem;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .additional-response {
    width: auto;
    height: 1rem;
    padding: 0.75rem
  }
</style>